"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaturnSurfing = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var ResourceType_1 = require("../../ResourceType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var SaturnSurfing = (function (_super) {
    __extends(SaturnSurfing, _super);
    function SaturnSurfing() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SATURN_SURFING,
            cost: 13,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.EARTH],
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: 'X11',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 floater from here to gain 1 M€ from each floater here, INCLUDING THE PAID FLOATER. Max 5.', function (eb) {
                        eb.floaters(1).startAction.megacredits(1).slash().floaters(1);
                        eb.asterix().text('max 5');
                    }).br;
                    b.floaters(1).slash().earth().played;
                }),
                description: 'Add 1 floater here for every Earth tag you have, including this.',
                victoryPoints: 1,
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    SaturnSurfing.prototype.play = function (player) {
        player.addResourceTo(this, player.getTagCount(Tags_1.Tags.EARTH) + 1);
        return undefined;
    };
    SaturnSurfing.prototype.canAct = function () {
        return this.resourceCount > 0;
    };
    SaturnSurfing.prototype.action = function (player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, Math.min(5, this.resourceCount--));
        return undefined;
    };
    SaturnSurfing.prototype.getVictoryPoints = function () {
        return 1;
    };
    return SaturnSurfing;
}(Card_1.Card));
exports.SaturnSurfing = SaturnSurfing;
//# sourceMappingURL=SaturnSurfing.js.map